import { Select, SelectProps, notification } from "antd";
import { useEffect, useState } from "react";
import APIClient from "../api/api";
import { Domain } from "../api/models";

export interface Props {
    domain: Domain;
    onChange?: (tags: string[]) => void;
}

const TagSelectDomain = (props: Props) => {
    const [options, setOptions] = useState<SelectProps["options"]>();
    const [value, setValue] = useState<string[]>(props.domain.tags ?? []);
    const [saving, setSaving] = useState(false);

    // Re-sync when the underlying domain changes (e.g. modal opened on a new domain).
    useEffect(() => {
        setValue(props.domain.tags ?? []);
    }, [props.domain.domain, props.domain.tags]);

    useEffect(() => {
        loadTags();
    }, []);

    async function onChange(values: string[]) {
        const previous = value;
        setValue(values);
        setSaving(true);
        try {
            await APIClient.setDomainTags(props.domain.domain, { tags: values });
            props.onChange?.(values);
        } catch (e) {
            console.log('failed to save', e);
            notification.error({ message: 'Failed to save tags for domain.' });
            setValue(previous);
        } finally {
            setSaving(false);
        }
    }

    async function loadTags() {
        try {
            const resp = await APIClient.listTags();
            setOptions(resp.tags.map(tag => ({ value: tag, label: tag })));
        } catch (e) {
            notification.error({ message: 'Failed to load tags.' });
        }
    }

    return (
        <Select
            mode="tags"
            style={{ width: '100%' }}
            loading={saving}
            disabled={saving}
            value={value}
            options={options}
            onChange={onChange}
        />
    );
};

export default TagSelectDomain;
